module.exports = __webpack_public_path__ + "static/img/2117_phase_function_Paper_PointsHejduk_Prediction.b913b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2117_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 6EOG
// module chunks = 0